<template>
    <div class="products px-360 px-xs-32">
        <!-- style="height: 1000px;" -->
        <XSTitle :main="yyMessage" :sub="titEN" class="hidden-sm-and-up"></XSTitle>
        <el-tabs v-model="activeName" :tab-position="wWidth<768?tabPosition[1]:tabPosition[0]" @tab-click="handleClick" :before-leave="beforeLeave">
            <el-tab-pane 
            v-for="(item,index) in activeProducts"
            
            :key="item.name"
            :name="item.name"
            >
                <span slot="label">
                    {{
                        index==3?
                        item.label.substring(0,item.label.indexOf('后')-4)+item.label.substring(item.label.indexOf('后')-2,item.label.indexOf('后'))
                        :item.label.substring(0,item.label.indexOf('实'))
                    }}<br class="hidden-sm-and-up">{{index==3?item.label.substring(item.label.indexOf('后')):item.label.substring(item.label.indexOf('实'))}}
                  <i class="el-icon-arrow-right hidden-xs-only" v-show="item.icon"></i>
                  <i class="el-icon-arrow-down hidden-xs-only" v-show="item.icon!=undefined&&!item.icon"></i>
                  <i class="el-icon-plus hidden-sm-and-up" v-show="item.icon"></i>
                  <i class="el-icon-minus hidden-sm-and-up" v-show="item.icon!=undefined&&!item.icon"></i>
                </span>
                <h1>{{item.label.match(/模体/)?"X线,CT,MRI":item.label}}</h1>
                <!-- pc的意思是 product content -->
                <component v-if="activeName == item.name" :is="item.com" class="px-38 pb-30 pc"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import XSTitle from '../../eyTitXs.vue'
export default {
    data() {
      return {
        yyMessage: '硬件产品',
        titEN: 'HARDWARE PRODUCTS',
        tabPosition: ['left','top'],
        activeName: 'mri',
        // mri 0 / ct 1 / dr 2 / handle 3 
        proItem:[
            {label:'MRI教学实训设备',name:'mri',flag:true,com:"com0"},
            {label:'CT教学实训设备',name:'ct',flag:true,com:"com1"},
            {label:'DR教学实训设备',name:'dr',flag:true,com:"com2"},
            {label:'三维医学影像后处理系统',name:'handle',flag:true,com:"com3"},
            {label:'超声教学实训设备',name:'supersound',flag:true,com:"com4"},
            {label:'医学人体模型',name:'dieBody',flag:true,icon:true,com:"com5"},
            {label:'X线、CT、MRI',name:'dieBodyMRI',flag:false,com:"com5"},
            {label:'X线、CT、超声',name:'dieBodyUS',flag:false,com:"com6"}
        ],
        wWidth: window.screen.width
      }
    },
    components:{
        com0: () => import("@/components/products/hardware/MRI.vue"),
        com1: () => import("@/components/products/hardware/CT.vue"),
        com2: () => import("@/components/products/hardware/DR.vue"),
        com3: () => import("@/components/products/hardware/handle.vue"),
        com4: () => import("@/components/products/hardware/supersound.vue"),
        com5: () => import("@/components/products/hardware/dieBody.vue"),
        com6: () => import("@/components/products/hardware/dieBodyUS.vue"),
        XSTitle
    },
  computed:{
    // 隐藏需要折叠的tab
    activeProducts: function () {
      return this.proItem.filter(function (pro) {
        return pro.flag;//返回flag=true的项，添加到activeProducts数组
      })
    }
  },
    methods:{
      // 展开与折叠判断  真假取反
      unflag(para,start,end,others){
        for(let i=start;i<end+1;i++){
          para[i].flag = !para[i].flag
        }
      },
        handleClick(tab,event){
          if(tab.name=="dieBody") {
            this.unflag(this.proItem,6,7)// 后两个参数是子菜单在proItem的索引
            this.proItem[5].icon = !this.proItem[5].icon
          }

        },
      // 当按钮涉及noEvent，禁止点击
        beforeLeave(newI,oldI){
          if(/noEvent/.test(newI)){
            return false
          }
        }

    }
}
</script>

<style lang="scss" scoped>
.products{
    margin: vw(20) 0 vw(28);

    ::v-deep {
        .el-tabs--left .el-tabs__header.is-left{
            margin-right: vw(20);
        }

        .el-tab-pane,
        .el-tabs__nav{
            background: $blueF3;
        }

        .el-tabs__nav{
            width: vw(240);
            padding: vw(20) vw(10);
        }

        .el-tabs__item{
            font-size: vw(16);
            padding: 0 vw(22);
            margin-bottom: vw(10);
            height: auto;
            font-weight: 500;
            line-height: 3;
            text-align: center;
            color: $blue096;
            background: white;
            border: 1px solid $blue096;
            border-radius: vw(5);

            &:hover,
            &.is-active{
                color: white;
                background: $blue096;
            }
        }

          // 内按钮样式
          #tab-dieBodyMRI,
          #tab-dieBodyUS{
            color: $font66;
            margin-bottom: vw(11);
            background: transparent;
            border: none;

            &:hover,
            &.is-active{
              color: $blue096;
              // background: $blue096;
            }
          }

          // 内按钮最后一个
          #tab-dieBodyUS{
            margin-bottom: vw(15);
          }

        .el-tabs__active-bar,
        .el-tabs__nav-wrap::after{
            display: none;
        }

        // ---------------  内容  ---------------
        .el-tabs__content{
            max-width: vw(940);
            transform-style: preserve-3d;

            &::before{
                // \00A0是空格
                content: 'Product\00A0\00A0\00A0\00A0introduction';
                font-size: vw(48);
                position: absolute;
                top: vw(26);
                left: vw(186);
                font-weight: bold;
                line-height: 1.25;
                color: rgba(211, 226, 244, 0.5);
                transform: translateZ(2px);
                // z-index: -1;
            }

            h1{
                font-size: vw(30);
                margin: 0;
                padding-top: vw(28);
                line-height: 2;
                color: $font18;
                transform: translateZ(4px);
            }
        }

        .pc{
            p{
                font-size: vw(18);
                text-align: left;
                text-indent: 2em;
                color: $font23;
                line-height: 2.5;
            }

            p:first-child{
                margin-top: 0;
                padding-top: 1rem;
            }
        }
    }

    // -------------------------------  手机端  -------------------------------

    @media only screen and (max-width: 767px){
        // margin-top: vp(-313);
        margin-top: vp(-270);
        margin-bottom: vp(30);

        ::v-deep {
            .el-tabs__header{
                margin: 0 0 vp(45);
            }

            .el-tabs__nav{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                padding: 0;
                width: 100%;
                background: transparent;
            }

            .el-tabs__item{
                font-size: vp(30);
                padding: vp(12) vp(14);
                // margin-right: vp(12);
                margin-bottom: vp(14);
                line-height: 1.3;
                border-radius: vp(5);
            }

            .el-tabs__nav-wrap.is-scrollable {
                padding: 0;
            }

            .el-tabs__nav-prev,
            .el-tabs__nav-next{
                display: none;
            }

            .el-tabs--top .el-tabs__item.is-top{

                &:nth-child(2){
                    padding-left: vp(22);
                }

                &:last-child{
                    padding-right: vp(22);
                }
            }
            .el-tabs__content{
                max-width: 100%;
                // margin-left: vp(-32);
                // margin-right: vp(-32);
                &::before{
                    display: none;
                }

                h1{
                    font-size: vp(36);
                    padding-top: vp(30);
                    line-height: 1.6;
                }

                .pc{
                    p{
                        font-size: vp(30);
                        line-height: 1.8;
                    }
                }
            }
        }
    }
}

</style>